import React, { useContext, useState } from 'react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import {
  Badge,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Tab,
  Tabs,
  TextField,
} from '@mui/material'
import InputMask from 'react-input-mask'
import { GlobalContext } from '../../../../App'
import { TerapiaAgendamento } from './TerapiaAgendamento'
import { ProdutoAgendamento } from './ProdutoAgendamento'
import { getdoc } from '../../../../components/api'
import FileExplorer from '../../../../components/FileExplorer/FileExplorer'
import { IoCloseCircleOutline } from 'react-icons/io5'

export const Timiline = ({ item }) => {
  const { agenda } = useContext(GlobalContext)
  const idAgendamento = item[4]
  const anamnese = item[5].split('\n')
  const diagnostico = item[6].split('\n')
  const prescricao = item[7].split('\n')
  const examesFisicos = item[16]?.split('\n')
  const [listaTerapia, setListaTerapia] = useState([])
  const [listaProduto, setListaProduto] = useState([])
  const [listaDocumentos] = useState(item[19])
  const [loadingArquivo, setLoadingArquivo] = useState(null)
  const [openDocumento, setOpenDocumento] = useState(false)
  const [urlDocumento, setUrlDocumento] = useState(null)

  const [tabSelect, setTabSelect] = useState(
    agenda[0] === 22 ||
      agenda[0] === 53 ||
      agenda[0] === 23 ||
      agenda[0] === 52 ||
      agenda[0] === 50 ||
      agenda[0] === 56
      ? 1
      : 0,
  )
  function getImc(peso, altura) {
    if (!peso || !altura) {
      return ''
    }
    return isNaN((peso / (altura * altura)).toFixed(2))
      ? ''
      : (peso / (altura * altura)).toFixed(2)
  }

  const handleVisualizar = async (arquivo) => {
    const token = arquivo?.[4]

    if (!token) return

    setLoadingArquivo(token)

    try {
      if (urlDocumento) {
        URL.revokeObjectURL(urlDocumento)
      }

      const res = await getdoc(token)
      const blob = await res.blob()

      const novaUrl = URL.createObjectURL(blob)

      setUrlDocumento(novaUrl)
      setOpenDocumento(true)
    } finally {
      setLoadingArquivo(null)
    }
  }

  const handleFecharDocumento = () => {
    if (urlDocumento) {
      URL.revokeObjectURL(urlDocumento)
    }

    setUrlDocumento(null)
    setOpenDocumento(false)
  }

  return (
    <div key={item[1]}>
      <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '400',
            border: '1px solid #CBCBCB',
            borderRadius: '10px',
            width: '60px',
            height: '60px',
            boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
            fontSize: '31px',
          }}
        >
          {format(new Date(item[2]), 'd', { locale: ptBR })}
        </span>
        <span
          style={{
            display: 'flex',
            width: '125px',
            height: '30px',
            borderRadius: '0px 10px 10px 00px',
            border: '1px solid #157FFB',
            backgroundColor: '#157FFB',
            boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
            fontSize: '18px',
            color: 'white',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {format(new Date(item[2]), 'MMM/y', { locale: ptBR })}
        </span>
      </div>
      <div style={{ display: 'flex', gap: '50px' }}>
        <span
          style={{
            display: 'flex',
            width: '2px',
            minHeight: '220px',
            backgroundColor: '#D6D6D6',
            marginLeft: '30px',
          }}
        />
        <div style={{ width: '100%' }}>
          {(agenda[0] === 22 ||
            agenda[0] === 53 ||
            agenda[0] === 23 ||
            agenda[0] === 52 ||
            agenda[0] === 50 ||
            agenda[0] === 56) && (
            <Tabs
              onChange={(e, value) => setTabSelect(value)}
              value={tabSelect}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              {/* 
              53	"Avaliação Nutricional (Marlowa)"
              22	"Avaliação Nutricional (Mônica)"

              50	"Avaliação Biológica (Tatiana)"
              56	"Avaliação Biológica (Taiana)"

              23	"Avaliação Psicológica (Ingrid)"
              52	"Avaliação Psicológica (Rosana)" 
              */}

              {(agenda[0] === 22 || agenda[0] === 53) && [
                agenda[15] === 'S' && (
                  <Tab
                    key="anam"
                    label={agenda[28] !== '' ? agenda[28] : 'Anamnese'}
                    value={0}
                  />
                ),
                <Tab
                  key="diag"
                  label={agenda[25] !== '' ? agenda[25] : 'Diagnóstico'}
                  value={1}
                />,
              ]}
              {(agenda[0] === 23 || agenda[0] === 52) && [
                agenda[15] === 'S' && (
                  <Tab
                    key="anam"
                    label={agenda[28] !== '' ? agenda[28] : 'Anamnese'}
                    value={0}
                  />
                ),
                <Tab
                  key={'psico'}
                  label={agenda[25] !== '' ? agenda[25] : 'Diagnóstico'}
                  value={1}
                />,
              ]}
              {(agenda[0] === 50 || agenda[0] === 56) && [
                agenda[15] === 'S' && (
                  <Tab
                    key="anam"
                    label={agenda[28] !== '' ? agenda[28] : 'Anamnese'}
                    value={0}
                  />
                ),
                <Tab
                  key={'bio'}
                  label={agenda[25] !== '' ? agenda[25] : 'Diagnóstico'}
                  value={1}
                />,
              ]}
            </Tabs>
          )}
          {agenda[0] === 21 && (
            <Tabs
              onChange={(e, value) => setTabSelect(value)}
              value={tabSelect}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="Terapias" value={9} />
              <Tab label="Suplementos" value={10} />
              <Tab label="Anamnese" value={0} />
              <Tab label="Exame Fisíco" value={5} />
              <Tab label="Diagnóstico" value={1} />
              <Tab label="Conduta" value={2} />
              <Tab label="Sinais" value={4} />
              <Tab
                label={
                  <Badge
                    badgeContent={listaDocumentos?.length || 0}
                    color="info"
                    max={99}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    sx={{
                      '& .MuiBadge-badge': {
                        right: -12,
                        top: 5,
                      },
                    }}
                  >
                    Anexos
                  </Badge>
                }
                value={3}
              />
            </Tabs>
          )}

          {/* 
            21	"Avaliação Médica"
            22	"Avaliação Nutricional"
            23	"Avaliação Psicológica"
            50	"Avaliação Biológica"
            */}

          <div
            style={{
              width: '100%',
              minHeight: '220px',
              backgroundColor: '#F1F1F1',
              borderRadius: '5px',
            }}
          >
            {tabSelect === 0 && (
              <div style={{ padding: '20px' }}>
                {anamnese.map((line, index) => (
                  <p key={index}>{line !== '' ? line : <>&nbsp;</>}</p>
                ))}
              </div>
            )}
            {tabSelect === 5 && (
              <div style={{ padding: '20px' }}>
                {examesFisicos?.map((line, index) => (
                  <p key={index}>{line !== '' ? line : <>&nbsp;</>}</p>
                ))}
              </div>
            )}
            {tabSelect === 1 && (
              <div style={{ padding: '20px' }}>
                {diagnostico.map((line, index) => (
                  <p key={index}>{line !== '' ? line : <>&nbsp;</>}</p>
                ))}
              </div>
            )}
            {tabSelect === 2 && (
              <div style={{ padding: '20px' }}>
                {prescricao.map((line, index) => (
                  <p key={index}>{line !== '' ? line : <>&nbsp;</>}</p>
                ))}
              </div>
            )}
            {tabSelect === 3 && (
              <div style={{ padding: '20px' }}>
                <div style={{ textAlign: 'right' }}>
                  <Dialog
                    open={openDocumento}
                    onClose={handleFecharDocumento}
                    maxWidth={false}
                    PaperProps={{
                      sx: {
                        width: '90vw',
                        height: '90vh',
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        backgroundColor: '#000',
                        overflow: 'hidden',
                        boxShadow: 'none',
                      },
                    }}
                  >
                    <IconButton
                      onClick={handleFecharDocumento}
                      sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 9999,
                        color: '#fff',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        '&:hover': {
                          backgroundColor: 'rgba(0,0,0,0.7)',
                        },
                      }}
                    >
                      <IoCloseCircleOutline />
                    </IconButton>

                    <DialogContent
                      sx={{
                        p: 0,
                        width: '100%',
                        height: '100%',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#000',
                      }}
                    >
                      <img
                        key={urlDocumento}
                        src={urlDocumento}
                        alt="Documento"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          width: 'auto',
                          height: 'auto',
                          objectFit: 'contain',
                          display: 'block',
                        }}
                      />
                    </DialogContent>
                  </Dialog>
                </div>
                <FileExplorer
                  arquivos={listaDocumentos}
                  loadingToken={loadingArquivo}
                  onClickArquivo={handleVisualizar}
                  justifyContent="flex-start"
                />
              </div>
            )}
            {tabSelect === 9 && (
              <div style={{ padding: '20px' }}>
                <TerapiaAgendamento
                  listaTerapia={listaTerapia}
                  setListaTerapia={setListaTerapia}
                  idAgendamento={idAgendamento}
                  disabilitado={true}
                />
              </div>
            )}
            {tabSelect === 10 && (
              <div style={{ padding: '20px' }}>
                <ProdutoAgendamento
                  listaProduto={listaProduto}
                  setListaProduto={setListaProduto}
                  idAgendamento={idAgendamento}
                  disabilitado={true}
                />
              </div>
            )}
            {tabSelect === 4 && (
              <div style={{ padding: '20px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <TextField
                      type="number"
                      label="Peso"
                      name="vlPeso"
                      disabled
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      value={item[9]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <InputMask mask="9.99" value={item[10]} disabled>
                      {() => (
                        <TextField
                          label="Altura"
                          name="vlAltura"
                          disabled
                          fullWidth
                          variant="outlined"
                          margin="dense"
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <TextField
                      disabled
                      label="IMC"
                      name="vlImc"
                      value={getImc(item[9], item[10])}
                      fullWidth
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <InputMask mask="99.9" value={item[11]} disabled>
                      {() => (
                        <TextField
                          label="Temperatura"
                          name="nrTemperatura"
                          disabled
                          fullWidth
                          variant="outlined"
                          margin="dense"
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <TextField
                      type="number"
                      label="Freq. respiratória"
                      name="nrFrequenciaRespiratoria"
                      disabled
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      value={item[12]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <TextField
                      type="number"
                      label="Freq. cardíaca"
                      name="nrFrequenciaCardiaca"
                      disabled
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      value={item[13]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <TextField
                      type="number"
                      label="PA sistólica"
                      name="nrPASistolica"
                      disabled
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      value={item[14]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3}>
                    <TextField
                      type="number"
                      label="PA Diastólica"
                      name="nrPADiastolica"
                      disabled
                      fullWidth
                      variant="outlined"
                      margin="dense"
                      value={item[15]}
                    />
                  </Grid>
                </Grid>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
